import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { CampaignStatus, CampaignStatusDetails, CampaignStatusSummary, BotanicCampaignStatus } from "src/app/models";
import { CognitoService } from "../../shared/services/cognito.service";

@Injectable({
    providedIn: 'root'
})
export class CampaignStatusService {
    headers:HttpHeaders | undefined
    // config:IConfig | undefined
    private http = inject(HttpClient);
    private cognitoService = inject(CognitoService);

    
    getAnchorStatusCounters(campaign_id:number) {  
        const params = new HttpParams()
            .set('campaign_id', campaign_id)      
        return this.http.get<CampaignStatusSummary[]>(this.cognitoService.appUri+'/get-anchor-status-counters', { params: params, observe: 'response' })
    }

    getCampaignsReport(){
        return this.http.get(this.cognitoService.appUri+'/campaign-report', { responseType: 'blob' });
    }

    getCampaigns() {        
        return this.http.get<CampaignStatus[]>(this.cognitoService.appUri+'/get-campaigns')
    }

    getCampaignStatusDetails(campaign_id:number,status:string){
        
        const params = new HttpParams()
        .set('campaign_id', campaign_id)
        .set('status', status);
        
        return this.http.get<CampaignStatusDetails[]>(this.cognitoService.appUri+'/campaign-status-details', { 'params':params })
    }

    putCampaignStatusCancel(id:string){
        
        const params = new HttpParams()
        .set('id', id)
        
        return this.http.put(this.cognitoService.appUri+'/campaign-update',null, { 'params':params })
    }

    getBotanicCampaignStatus(campaign_id:number){
        const params = new HttpParams().set('campaign_id', campaign_id)
        return this.http.get<BotanicCampaignStatus>(this.cognitoService.appBotanicUri+'/get-campaign-status', { 'params':params })
    }

}